import React from "react";
import { Navbar, Footer, } from "../../components/shared";
import useCheckLoggedin from "../../utils/useCheckLoggedin";
import { Helmet } from "react-helmet-async";
import '../general/General.css';
import FamilyDetails from "./FamilyDetails";
import { Breadcrumbs } from '../../components/shared';

const UserFamily = () => {
  useCheckLoggedin(); // Check if the user is logged in (if no user data, redirect to login)
  return (
    <>
      <Helmet>
        <title>பயனர் குடும்பம்</title>
        <link rel="canonical" href="/user/profile" />
      </Helmet>
      <Navbar />

      <div className="general_parent">
        <div className="general_container">
          <div className="general_body">
            <div className="detail-card">
              <Breadcrumbs /><br />
              <FamilyDetails />
            </div>

          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default UserFamily;
